import HeaderTableView from './HeaderTableView';

export default HeaderTableView;
